import { connect } from 'react-redux';
import { update } from '../../store/auth';
import { actions as profileActions } from '../../store/profile';

const AUTH_NOMFA = 'NOMFA';

function isMFAEnabled(preferredMFA) {
  return Boolean(preferredMFA && preferredMFA !== AUTH_NOMFA);
}

function mapStateToProps(state) {
  return {
    authUser: state.auth || {},
    profilePending: state.profile?.pending,
  };
}

function getAuthUpdatePayload(result = {}, submittedData = {}) {
  return {
    email: result.email || submittedData.email,
    name: result.name || result.firstName || submittedData.firstName,
    familyName: result.familyName || result.lastName || submittedData.lastName,
    timezone: result.timezone || submittedData.timezone,
    formatDate: result.formatDate || submittedData.formatDate,
    authTimezone: result.authTimezone || result.timezone || submittedData.timezone,
    phone: result.phone || submittedData.phone,
    jobTitle: result.jobTitle || submittedData.jobTitle,
    linkedInUrl: result.linkedInUrl || submittedData.linkedInUrl,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updatePersonalInformation: async (data) => {
      const action = await dispatch(profileActions.updatePersonalInformation(data));

      if (profileActions.updatePersonalInformation.fulfilled.match(action)) {
        const result = action.payload || {};
        dispatch(update(getAuthUpdatePayload(result, data)));
        return result;
      }

      throw action.error || new Error('Unable to update personal information.');
    },

    updateMFA: async (preferredMFA) => {
      const action = await dispatch(profileActions.setMFA({ mfa: preferredMFA }));

      if (profileActions.setMFA.fulfilled.match(action)) {
        dispatch(update({
          '2faActive': preferredMFA !== AUTH_NOMFA ? preferredMFA.toLowerCase() : null,
          mfaEnabled: isMFAEnabled(preferredMFA),
          preferredMFA,
        }));

        return true;
      }

      throw action.error || new Error('Unable to update two-factor authentication.');
    },

    updatePhone: (phone) => {
      return dispatch(update({ phone }));
    },

    updatePhoneVerified: (isVerified) => {
      return dispatch(update({ phoneVerified: isVerified }));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps);